// 主要是初始化瓦片地图，这些状态要共享给所有用到地图得子模块
import baseLayer from "./helper/base-layer";
export default function init(store) {
  var _window$GLOBAL_CONFIG = window.GLOBAL_CONFIG.mapConfig,
      titleLayer = _window$GLOBAL_CONFIG.titleLayer,
      tileLayer = _window$GLOBAL_CONFIG.tileLayer;
  store.commit('SET_TITLE_LAYERS', tileLayer || titleLayer || baseLayer);
}